import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPosOrder = fp.get('POS.order');

export const getAll = createSelector(getPosOrder, fp.get('all'));
export const getAllValues = createSelector(getAll, fp.values);
export const getOrderForId = createSelector((_, id) => id, getAll, fp.get);
export const getOrderForVisitTrackId = createSelector(
  (_, visitTrackId) => ({ visitTrackId }),
  getAllValues,
  fp.find
);

export const getIsFetching = createSelector(getPosOrder, fp.get('fetching'));
export const getIsFetched = createSelector(getPosOrder, fp.get('fetched'));
export const getFetchingError = createSelector(
  getPosOrder,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(getPosOrder, fp.get('saving'));
export const getSavingError = createSelector(
  getPosOrder,
  fp.get('savingError')
);

export const getSavingAdjustmentErrorItems = createSelector(
  getSavingError,
  fp.flow(
    fp.get('error'),
    fp.keyBy('field')
  )
);

export const getIsSavingItem = createSelector(
  getPosOrder,
  fp.get('savingItem')
);
export const getIsSavedItem = createSelector(getPosOrder, fp.get('savedItem'));

export const getSavingItemErrors = createSelector(
  getPosOrder,
  fp.get('savingItemErrors')
);

export const getIsDeletingItem = createSelector(
  getPosOrder,
  fp.get('deletingItem')
);
export const getIsDeledItem = createSelector(
  getPosOrder,
  fp.get('deletedItem')
);

export const getDeletingItemError = createSelector(
  getPosOrder,
  fp.get('deletingItemError')
);
